import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import useCurrentUser from "./useCurrentUser";
import { toast } from "react-hot-toast";

const PrivateRoute = ({ allowedRoles }) => {
  const { currentUser, loading } = useCurrentUser();

  useEffect(() => {
    if (!loading && (!currentUser || !Array.isArray(currentUser.empRole))) {
      toast.error("Unauthorized. You do not have the necessary permissions.");
    }
  }, [currentUser, loading, allowedRoles]);

  if (loading) {
    // return <div>Loading...</div>;
    console.log("Loading login user data...");
  }

  // Check if the user is authorized by comparing empRole and allowedRoles
  const isAuthorized = currentUser?.empRole?.some((role) =>
    allowedRoles.includes(role)
  );

  return isAuthorized ? (
    <Outlet />
  ) : (
    <div>You do not have permission to view this page.</div>
  );
};

PrivateRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PrivateRoute;
